// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"Yu-z","expressButtonContainerWithPayPal":"Zu-z","expressButton":"_u-z","or":"av-z"};